import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

import { onMounted, ref, watch, computed } from "vue";
import { getTransactionsEstimationsTmoa } from "@/utils/tmoa.util.ts";
import { Estimation } from "@/types/estimation.type";
import { Tmoa } from "@/types/tmoa.type";


export default /*#__PURE__*/_defineComponent({
  props: {
    estimations: null,
    tmoas: null,
    reverse: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  estimations: Estimation[];
  tmoas: Tmoa[];
  reverse: boolean;
}

const tableTransactions = ref<any[]>([]);
const columnKeys = ref<string[]>([]);



const getCellClass = (row: any, col: string) => {
  return row?._cellClassMap?.[col] ?? "";
};

function parsePercentage(raw: any): number {
  if (raw == null) return 0;
  if (typeof raw === "number") return raw;
  const s = String(raw).trim().replace("%", "").replace(",", ".");
  const n = parseInt(s);
  return Number.isFinite(n) ? n : 0;
}

const createTransaction = () => {
  tableTransactions.value = [];
  columnKeys.value = [];
  const percentages = getTransactionsEstimationsTmoa(props.estimations);

  props.tmoas.forEach((tmoaCol) => {
    columnKeys.value.push(tmoaCol.name);
  });

  props.tmoas.forEach((tmoaRow) => {
    const row: any = { name: tmoaRow.name };
    const valuesForRanking: Array<{ colName: string; raw: string; num: number }> = [];

    props.tmoas.forEach((tmoaCol) => {
      const raw = percentages?.[tmoaCol.value]?.[tmoaRow.value] ?? "0 %";
      row[tmoaCol.name] = raw;
      const num = parsePercentage(raw);
      valuesForRanking.push({ colName: tmoaCol.name, raw, num });
    });

    const uniquePositives = Array.from(
      new Set(valuesForRanking.map((v) => v.num).filter((n) => n > 0))
    ).sort((a, b) => b - a);

    const topValues = uniquePositives.slice(0, 3);

    const cellClassMap: Record<string, string> = {};
    for (const entry of valuesForRanking) {
      const n = entry.num;
      if (n <= 0) {
        cellClassMap[entry.colName] = "";
        continue;
      }
      if (n === topValues[0]) {
        cellClassMap[entry.colName] = "top1";
      } else if (n === topValues[1]) {
        cellClassMap[entry.colName] = "top2";
      } else if (n === topValues[2]) {
        cellClassMap[entry.colName] = "top3";
      } else {
        cellClassMap[entry.colName] = "";
      }
    }

    row._cellClassMap = cellClassMap;
    tableTransactions.value.push(row);
  });
};

onMounted(() => {
  createTransaction();
});

watch(
  () => [props.estimations, props.tmoas],
  () => {
    createTransaction();
  },
  { deep: true, immediate: true }
);

const transposedTable = computed(() => {
  if (!tableTransactions.value.length || !columnKeys.value.length) return [];

  const original = tableTransactions.value;
  const rowsNames = original.map((r) => r.name);

  return columnKeys.value.map((colName) => {
    const newRow: any = { name: colName };
    const rankingArray: Array<{ colName: string; num: number }> = [];

    for (const origRow of original) {
      const raw = origRow[colName];
      newRow[origRow.name] = raw;

      const n = parsePercentage(raw);
      rankingArray.push({ colName: origRow.name, num: n });
    }

    const uniquePositives = Array.from(
      new Set(rankingArray.map((v) => v.num).filter((n) => n > 0))
    ).sort((a, b) => b - a);

    const topValues = uniquePositives.slice(0, 3);

    const newCellMap: Record<string, string> = {};
    for (const entry of rankingArray) {
      if (entry.num === topValues[0]) newCellMap[entry.colName] = "top1";
      else if (entry.num === topValues[1]) newCellMap[entry.colName] = "top2";
      else if (entry.num === topValues[2]) newCellMap[entry.colName] = "top3";
      else newCellMap[entry.colName] = "";
    }

    newRow._cellClassMap = newCellMap;
    return newRow;
  });
});

const transposedColumnKeys = computed(() => {
  return tableTransactions.value.map((r) => r.name);
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _unref(transposedTable),
    border: "",
    class: "tables"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        prop: "name",
        label: __props.reverse ? 'A/De' : 'De/A',
        style: {"text-align":"center"},
        "min-width": "65"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", null, _toDisplayString(scope.row.name), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transposedColumnKeys), (col) => {
        return (_openBlock(), _createBlock(_component_el_table_column, {
          key: col,
          prop: col,
          label: col,
          "min-width": "80",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", {
              class: _normalizeClass(['cell-value', getCellClass(scope.row, col)])
            }, _toDisplayString(scope.row[col]), 3)
          ]),
          _: 2
        }, 1032, ["prop", "label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})